import { render, staticRenderFns } from "./HelpLayout.vue?vue&type=template&id=22b148c6&scoped=true"
import script from "./HelpLayout.vue?vue&type=script&lang=js"
export * from "./HelpLayout.vue?vue&type=script&lang=js"
import style0 from "./HelpLayout.vue?vue&type=style&index=0&id=22b148c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b148c6",
  null
  
)

export default component.exports